export const EmptyState = () => {
  return (
    <div className="flex items-center px-6 py-3">
      <div className="flex-1 mr-4">
        <span className="text-sm text-muted-foreground">Sem video</span>
      </div>
    </div>
  )
}
